import { OfferType } from '../../common/enums.js';
import { ProductOfferingsCardsByOfferTypeCoCo } from '../OrderSubscriptionSelection/ProductOfferingsCardsByOfferTypeCoCo.js';
import {
  AreYouAConsumerCustomer,
  DisjointedGenericInformationAboutLaitenetti,
  ElisaLaitenettiApp,
  FAQ,
  LaitenettiSubscriptionFeatures,
  PublicM2MHeader,
  PublicMobileM2MBreadcrumbs,
} from '../PublicM2MSubscriptions/PublicM2MSubscriptions.js';
import { PublicSelfServiceBanner } from '../PublicSelfServiceBanner/PublicSelfServiceBanner.js';

export const PublicMobileBroadbandProductOfferingsCoCo = () => {
  return (
    <section className="of-public-mobile-broadband-subscriptions of-public-page">
      <PublicMobileM2MBreadcrumbs />
      <PublicM2MHeader />
      <ProductOfferingsCardsByOfferTypeCoCo offerType={OfferType.MOBILE_BROADBAND} publicPages />
      <PublicSelfServiceBanner />
      <LaitenettiSubscriptionFeatures />
      <ElisaLaitenettiApp />
      <DisjointedGenericInformationAboutLaitenetti />
      <FAQ />
      <AreYouAConsumerCustomer />
    </section>
  );
};
